import React, { Component } from 'react'
import { Icon } from '../menu/primitives.components'

const addUtmSource = (link, analyticsName) =>
  `${link}?view_source=nav_bar&viewmedium=nav_bar_${analyticsName}`
const ROOT = '/'
export class NavItemContainer extends Component {
  constructor() {
    super()
  }

  navItemClicked(ev) {
    this.props.onCategorySelected()
  }

  renderMenuNavItem() {
    let wrapperSelectedClass = 'nav__icon'
    let itemContainerSelectedClass = 'nav__item__text'
    let itemTriangleClass = 'nav__item__triangle'

    if (this.props.isOpen) {
      wrapperSelectedClass = `${wrapperSelectedClass} nav__icon__selected`
      itemContainerSelectedClass = `${itemContainerSelectedClass} nav__item__text__selected`
      itemTriangleClass = `${itemTriangleClass} nav__item__triangle__open`
    }

    return (
      <div onClick={ev => this.navItemClicked(ev)} className="nav__item__link">
        <Icon size="20" className={wrapperSelectedClass} iconName={this.props.icon} />
        <div className="nav__item__container">
          <div className={itemContainerSelectedClass}>
            {this.props.description}
          </div>
          <div className={itemTriangleClass} />
        </div>
      </div>
    )
  }

  isLinkNavItemSelected() {
    return this.props.selectedNavItem !== ROOT && this.props.url === this.props.selectedNavItem
  }

  isIconColorful() {
    return this.props.icon.includes('.embedded')
  }

  getLinkIconStyle() {
    return this.props.isOpen || !this.isLinkNavItemSelected()
  }

  renderLinkNavItem() {
    return (
      <a
        className="nav__item__link"
        href={addUtmSource(this.props.url, this.props.analytics)}
        data-analytics-event-category="Navigation"
        data-analytics-event-action="nav bar click"
        data-analytics-event-label={this.props.analytics}
        data-analytics-event-sub-label={this.props.index}
      >
        <Icon
          size="20"
          className={this.getLinkIconStyle() ? 'nav__icon' : 'nav__icon__selected'}
          iconName={this.props.icon}
        />
        <div className="nav__item__container">
          <div
            className={`nav__item__text ${this.isLinkNavItemSelected() && !this.props.isOpen
              ? 'nav__item__text__selected'
              : ''}`}
          >
            {this.props.description}
          </div>
        </div>
      </a>
    )
  }

  render() {
    return (
      <div>
        {this.props.isHaveCategories ? this.renderMenuNavItem() : this.renderLinkNavItem()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/navigation/navItem.container.js